import { useEnvironment } from '@wix/yoshi-flow-editor';
import classNames from 'classnames';
import React, { type FC } from 'react';
import { Toast as TPAToast, ToastPlacement } from '@wix/wix-ui-tpa/cssVars';

import { useWidget } from '../../../contexts/widgets/hooks';
import classes from './Toast.scss';

const Toast: FC = () => {
  const { isMobile } = useEnvironment();
  const { ui, handlers } = useWidget();
  const { hideToast } = handlers;

  const { toast } = ui;

  return (
    <TPAToast
      className={classNames({
        [classes.toast]: true,
        [classes.displayNone]: !toast.isVisible,
        [classes.mobile]: isMobile,
      })}
      skin={toast.skin}
      children={toast.message}
      placement={
        isMobile ? ToastPlacement.bottomFullWidth : ToastPlacement.inline
      }
      isShown={toast.isVisible}
      shouldShowCloseButton={true}
      onClose={() => hideToast()}
    />
  );
};

export default Toast;
